import "./Navbar.css"
import logo from "../../../assets/logo.png"
import {UilTimes, UilBars} from "@iconscout/react-unicons";
import {useState, useEffect} from "react";
import {NavLink, useLocation} from "react-router-dom";
import pdf from "../../../assets/pdf/ARNIKUP.pdf"

const Navbar = () => {
    const [navState, setNavState] = useState("")
    const [navKey, setNavKey] = useState(0);
    const location = useLocation();

    useEffect(() => {
        setNavKey(prevKey => prevKey + 1);
    }, [location.pathname]);


    return (
        <div className="navbar-container" key={navKey}>
            <div className="navbar">
                <img src={logo} alt="logo"/>
                <div className={`ham-nav ${navState}`}>
                    <ul>
                        <li className={"mobile"}>
                            <UilTimes onClick={() => setNavState("")}/>
                        </li>
                        <li style={{animationDelay: "1.9s"}}>
                            <NavLink
                                onClick={() => setNavState("")}
                                to="/"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                HOME
                            </NavLink></li>
                        <li style={{animationDelay: "2s"}}>
                            <NavLink
                                onClick={() => setNavState("")}
                                to="/laboratory"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                LABORATORY
                            </NavLink>
                        </li>
                        <li style={{animationDelay: "2.1s"}}>
                            <NavLink
                                onClick={() => setNavState("")}
                                to="/portfolio"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                PORTFOLIO
                            </NavLink>
                        </li>
                        <li style={{animationDelay: "2.2s"}}>
                            <NavLink
                                onClick={() => setNavState("")}
                                to="/team"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                TEAM
                            </NavLink>
                        </li>
                        <li style={{animationDelay: "2.3s"}}>
                            <NavLink
                                onClick={() => setNavState("")}
                                to="/contact"
                                end
                                className={({isActive}) => (isActive ? 'active' : '')}>
                                CONTACT
                            </NavLink>
                        </li>
                        <li className={"mobile"}>
                            <div className={"catalog-mobile"}>
                                <a href={pdf} rel="noreferrer" target={"_blank"}>
                                    Catalog
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="catalog pc" style={{animationDelay: "2.4s"}}>
                    <a href={pdf} rel="noreferrer" target={"_blank"}>
                        <div>
                            Catalog
                        </div>
                    </a>
                </div>
                <div className={"mobile"}>
                    <UilBars color={"white"} onClick={() => setNavState("open-nav")}/>
                </div>
            </div>
        </div>
    )
}
export default Navbar;